<template>
  <model-viewer
    :src="src"
    autoplay
    :animation-name="currentAnim"
    animation-crossfade-duration="260"
    camera-orbit="0deg 82deg 100%"
    interaction-prompt="none"
    disable-zoom
    exposure="1.35"
    shadow-intensity="0.7"
    :style="viewerStyle"
    @load="onLoad"
  ></model-viewer>
</template>

<script>
// Robot-asystent BTP (Poddy M1, CC BY 4.0 — kredyt w Centrum Pomocy).
// Animacje w GLB: Idle (lewitacja), Wave (machnięcie 2,8 s), Sad (pusty stan).
export default {
  name: 'AssistantRobot',
  props: {
    anim: { type: String, default: 'Idle' },   // animacja bazowa: Idle | Sad
    greet: { type: Boolean, default: false },  // machnięcie po załadowaniu
    size: { type: Number, default: 160 },      // szerokość w px (wysokość ∝ 1.25)
  },
  data() {
    return { currentAnim: this.anim, waveTimer: null };
  },
  computed: {
    src() {
      return `${process.env.BASE_URL}garage3d/asystent-robot.glb`;
    },
    viewerStyle() {
      return {
        width: `${this.size}px`,
        height: `${Math.round(this.size * 1.25)}px`,
        pointerEvents: 'none', // kliki łapie rodzic (może wywołać wave())
        '--poster-color': 'transparent',
      };
    },
  },
  mounted() {
    // dystrybucja! wersja źródłowa wymaga peer-dep three i wywala build
    import('@google/model-viewer/dist/model-viewer.min.js');
  },
  beforeDestroy() {
    clearTimeout(this.waveTimer);
  },
  methods: {
    onLoad() {
      if (this.greet) this.wave();
    },
    wave() {
      this.currentAnim = 'Wave';
      clearTimeout(this.waveTimer);
      // Wave kończy się w pozie spoczynkowej na 2,8 s — wracamy tuż przed pętlą
      this.waveTimer = setTimeout(() => { this.currentAnim = this.anim; }, 2700);
    },
  },
};
</script>
